import React,{useEffect, useState, useMemo} from 'react';
import parse from 'html-react-parser';
import TextInput from './FormInputs/TextInput';
import TextareaInput from './FormInputs/TextareaInput';
import SelectInput from './FormInputs/SelectInput';
import CheckboxInput from './FormInputs/CheckboxInput';
import RadioGroupInput from './FormInputs/RadioGroupInput';
import CompanySelectController from './FormInputs/CompanySelectController';
import CompanyDirectorDetailsController from './FormInputs/CompanyDirectorDetailsController';
import CompanyDirectorSelectController from './FormInputs/CompanyDirectorSelectController';
import YesNoInput from './FormInputs/YesNoInput';
import AddressInputController from './FormInputs/AddressInputController';
import BankAccountsInputController from './FormInputs/BankAccountsInputController';
import OfficersAndPSCsInputController from './FormInputs/OfficersAndPSCsInputController';
import {getRowsFromFields} from '../helpers/getRowsFromFields'
import evaluateLogic from '../helpers/evaluateLogic'
// import injectBaseFields from '../helpers/injectBaseFields';
import nonmemdefaultValues from '../helpers/nonmemdefaultValues'

import {useWatch, useForm, FormProvider } from 'react-hook-form';
import '../form.css'
import './FormPage.css';






const renderFields = (rows, errors, register, company_number, formValues) => {


  if((rows??[]).length === 0)
    return (
    <>
      <h1>Nothing To Preview</h1>
      <h6>No Fields have been added yet.</h6>
    </>
  )
  return (
    <div className="form-page">
      {rows.map((row, rowIndex) => (
        <div className="form-row" key={`row_${rowIndex}`}>
          {row.columns.map((field,colindex) => {

            const shouldDisplay = !field.logic || evaluateLogic(field.logic, formValues);

            if (!shouldDisplay) return null;

            const style = {
              fontSize: field.fontSize??10,
              color: field.color??'black',
              fontWeight: field.fontWeight??'normal',
              flexBasis: `${field.colSpan * 25}%`,
              maxWidth: `${field.colSpan * 25}%`,
              width: `${field.colSpan * 25}%`,
              textAlign: `${field.align??'left'}`,
              flexGrow: 1,
              textTransform: `${field.textCase??'none'}`
            };

            let commonProps = {
              label: field.label,
              name: field.name,
              register,
              errors,
              required: field.required,
              showRequiredIndicator: field.showRequiredIndicator,
              align: field.align,
              sx: field.sx || {},
              helptext: field.helptext,
            };

            let addrProps = {
              addresstype: field.addresstype,
              maxaddrs: field.maxaddrs
            }

            if(["text","email","postcode", "number", "currency","company"].includes(field.type) )
              commonProps.placeholder = field.placeholder??'';


            switch (field.type) {
              case 'text':
              case 'email':
              case 'number':
              case 'date':
              case 'datetime':
              case 'currency':
              case 'postcode':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <TextInput
                    key={field.name}
                      type={field.type === 'currency' ? 'number' : (field.type === 'datetime' ? 'datetime-local' : field.type)}
                      {...commonProps}
                    />
                  </div>
                );
              case 'company':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <CompanySelectController
                      name="company_number"
                      label="Find Your Comopany"
                      key={field.name}
                      {...commonProps}
                    />
                  </div>
                );
              case 'textarea':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <TextareaInput rows={field.rows || 4} {...commonProps}
                    key={field.name}
                    />
                  </div>
                );
              case 'select':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <SelectInput options={field.options} {...commonProps} key={field.name}/>
                  </div>
                );
              case 'checkbox':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <CheckboxInput {...commonProps} key={field.name}/>
                  </div>
                );
              case 'radio':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <RadioGroupInput options={field.options} {...commonProps} key={field.name} />
                  </div>
                );
              case 'yesno':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <YesNoInput {...commonProps} key={field.name} />
                  </div>
                );
              case 'address':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <AddressInputController
                      key={field.name}
                      addresstype={field.addresstype??''}
                      {...commonProps}
                      {...addrProps}
                    />
                  </div>
                );
              case 'companydirectors':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <CompanyDirectorDetailsController
                      key={field.name}
                      company_number={company_number}
                      {...commonProps}

                    />
                  </div>
                );
              case 'bankaccounts':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <BankAccountsInputController
                      key={field.name}
                      {...commonProps}
                    />
                  </div>
                );
              case 'officers_and_pscs':
                return (
                  <div className="form-col" style={style} key={field.name}>
                    <OfficersAndPSCsInputController
                      key={field.name}
                      company_number={company_number}
                      {...commonProps}
                    />
                  </div>
                );
              case 'companydirectorselect':

              return (                  
                <div className="form-col" style={style} key={field.name}>
                  <CompanyDirectorSelectController
                    field={field}
                    key={field.name}
                    company_number={company_number}
                    {...commonProps}

                  />
                </div>
              )
              case 'companydirectorsselect':
                return null;
              case 'group':
                  return (<fieldset key={`group_leg+${colindex}`}><legend>{field.label}</legend></fieldset>);

              case 'styledText':
              case 'html':
                return (
                  <div
                    key={`stext_${colindex}`}
                    style={{...style, textAlign: field.alignheading || 'left'}}
                    className={`${field.italic?'italic':''} ${field.underline?'underline':''}`}
                  >
                    {field.content ? parse(field.content) : ''}
                  </div>
                );

              case 'htmltemplateeditor':
                return (
                  <div
                    key={`htmltemplate_${colindex}`}
                    style={{...style, border: '1px dashed #ccc', padding: '15px', backgroundColor: '#f8f9fa'}}
                  >
                    <strong>{field.label}</strong>
                    <div style={{fontSize: '0.85rem', color: '#6c757d', marginTop: '5px'}}>
                      {field.template ?
                        `Template defined (${field.template.length} characters)` :
                        'No template defined'}
                    </div>
                  </div>
                );

              case 'heading':
                const HeadingTag = field.tag || 'h3'; // default to h3 if not specified
                return (
                  <HeadingTag
                    key={field.id}
                    style={{
                      fontSize: field.fontSize || '1.5em',
                      color: field.color || '#000',
                      fontWeight: field.fontWeight || 'bold',
                      margin: field.margin || '10px 0',
                      textAlign: field.alignheading || 'left',
                      width: `${field.colSpan * 25}%`,
                    }}
                  >
                    {field.label}
                  </HeadingTag>
                );

              default:
                return <div key={`${colindex}_${field.name}`} >Unsupported field type: {field.type}</div>;
            }
          })}
        </div>
      ))}
    </div>
  );
}

const FormPage = ({ fields }) => {

  const defaultValues = useMemo(() => ({nonmemdefaultValues}), []);

  const methods = useForm({ defaultValues });
  const { register, control, formState: { errors } } = methods;
  const [company_number, setCompanyNumber] = useState('')
  const formValues = useWatch({ control });

useEffect(() => {
  console.log("🧠 Live Form Values:", formValues);
  if((formValues.company_number??'')  > '')
      setCompanyNumber(formValues.company_number??'')
}, [formValues]);

  if (!Array.isArray(fields)) return null;
  // Convert flat field list into rows based on colSpan logic
  const rows = getRowsFromFields(fields);

  return (
    <FormProvider {...methods}>
      {renderFields(rows,errors, register, company_number, formValues)}
    </FormProvider>
  )
}

export default FormPage;